import React from 'react';
import PropTypes from 'prop-types';
import SearchSectionNode from '@Pages/QueryBuilder/SearchSection/SearchSectionNode/SearchSectionNode';

function SearchedQuerylets({ nodes, addToBuilder }) {
  return (
    <div className="query-builder-search-section__searched-querylets">
      {nodes.length > 0 ? (
        nodes.map((node, index) => (
          <SearchSectionNode
            // eslint-disable-next-line react/no-array-index-key
            key={`level-0-index-${index}`}
            node={node}
            level={0}
            index={index}
            isSearched
            addToBuilder={addToBuilder}
          />
        ))
      ) : (
        <div className="query-builder-search-section__empty-tab">
          <strong className="query-builder-search-section__empty-tab-short-msg query-builder-search-section__empty-tab-short-msg--no-results">
            No results.
          </strong>
          <div className="query-builder-search-section__empty-tab-long-msg">Check your spelling or try another search term.</div>
        </div>
      )}
    </div>
  );
}

SearchedQuerylets.propTypes = {
  nodes: PropTypes.array.isRequired,
  addToBuilder: PropTypes.func.isRequired,
};

export default SearchedQuerylets;
